<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-h3`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M3 5a1 1 0 00-1 1v36a1 1 0 001 1h2a1 1 0 001-1V26h17v16a1 1 0 001 1h2a1 1 0 001-1V6a1 1 0 00-1-1h-2a1 1 0 00-1 1v16H6V6a1 1 0 00-1-1H3zm34.835 21.983a1 1 0 00-1 1v1.245a1 1 0 001 1h.542c1.133 0 2.068.345 2.804 1.035.748.714 1.133 1.72 1.157 3.018-.024 1.275-.41 2.257-1.157 2.947-.736.737-1.641 1.105-2.716 1.105-1.005 0-1.81-.274-2.418-.824a4.724 4.724 0 01-.865-1.024 5.272 5.272 0 01-.244-.453 1.043 1.043 0 00-.93-.593H32.24c-.638 0-1.123.592-.948 1.204l.037.12c.472 1.492 1.233 2.676 2.282 3.553C34.954 41.439 36.497 42 38.237 42c2.255-.023 4.1-.743 5.538-2.158 1.46-1.38 2.202-3.269 2.225-5.667a7.256 7.256 0 00-.683-3.087c-.48-.983-1.256-1.825-2.331-2.527 1.051-.713 1.782-1.526 2.19-2.438.35-.913.526-1.86.526-2.842-.023-1.942-.69-3.626-1.998-5.053-1.366-1.462-3.212-2.205-5.537-2.228-1.834.023-3.411.678-4.731 1.965-1.005.97-1.686 2.108-2.044 3.413-.02.07-.039.153-.058.243-.127.594.349 1.133.956 1.133h1.752c.45 0 .838-.302.985-.726a3.277 3.277 0 011.142-1.607c.643-.503 1.356-.754 2.138-.754 1.087.023 1.974.368 2.664 1.035.689.69 1.045 1.573 1.069 2.649 0 1.064-.345 1.93-1.034 2.596-.69.69-1.659 1.036-2.909 1.036h-.262z"/></svg>
</template>
<script>

export default {
  name: 'IconH3',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
